module.exports = "/_next/static/images/rda-d6e61425365b298c3552c5d1a7d66fc6.png";